import moment from "moment";
import Select from "react-select";
import { CSVLink } from "react-csv";
import React, { Fragment } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
} from "reactstrap";
import Page from "../components/Page";
import {
  MdDeleteForever,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdEdit,
} from "react-icons/md";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { FaClone, FaArchive } from "react-icons/fa";
import { HiDownload } from "react-icons/hi";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import * as Server from "../Server";
import config from "./../config/local";
import EventDetails from "./EventDetails";
import RushDataEdit from "./RushData-Edit";
import PageSpinner from "../components/PageSpinner";
import * as GeneralFunctions from "../GeneralFunctions";
import { GlobalContext } from "../components/Layout/MainLayout";

let selectedCampId = null;
let user = {};
// let csvData = [];
// let csvHeaders = [];
class RushData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      removeCampConfirmationModal: false,
      camp: {},
      Camps: [],
      page: 1,
      limit: 10,
      totalCamps: 0,
      pages: 0,
      pageNumbers: [],
      campDetail: {},
      teamModel: false,
      campEditPage: false,
      campEditKey: "",
      collapseCampdetail: null,
      dashboardDetails: {},
      archiveCampConfirmationModal: false,
      parentEvents: [],
      selectedParentEvent: {},
      registerUrl: "",
      csvData: [],
      csvHeaders: [],
      eyeTooltip: false,
      eyeOffTooltip: false,
      selectedIndex: null,
    };
    this.shopToken = null;
  }
  componentDidMount() {
    user = GeneralFunctions.getAuthUser();
    if (!user.connectUserId) {
      GeneralFunctions.clearFullLocalStorage();
      window.location.assign(`${config.stripeConnectUrl}&state=${user._id}`);
    }
    this.getDashboardDetails();
    if (user.connectedUser && user.connectedUser.SPIEvent) this.getSPIEvents();
    if (user.connectedUser && !user.connectedUser.SPIEvent)
      this.setState({ limit: this.context.limit }, () => this.getCamps());
  }

  getDashboardDetails = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/dashboard",
        method: "POST",
      });
      if (response) {
        this.setState({
          showLoader: false,
          dashboardDetails: response.details,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.request({
        url: "camp/list",
        method: "POST",
        data: {
          page,
          pageLimit,
          parentEventId: this.state.selectedParentEvent.value,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          Camps: response.camps,
          totalCamps: response.totalCamps,
          pages: response.pages,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getSPIEvents = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/rushNational/camps",
        method: "GET",
      });
      if (response) {
        this.setState(
          {
            // showLoader: false,
            parentEvents: response.camps,
            selectedParentEvent: {
              value: response.camps[0]._id,
              label: response.camps[0].name,
            },
            limit: this.context.limit,
            registerUrl: `${window.location.origin}/event/register/${response.camps[0].name}`,
          },
          () => this.getCamps()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderCampEditPage = (camp, key) => {
    if (key === "Event-Create") {
      this.setState({ campEditPage: true, campEditKey: key });
    } else if (key === "Event-Clone") {
      this.setState({
        campEditPage: true,
        campEditKey: "Event-Create",
        campDetail: camp,
      });
    } else {
      this.setState({ campEditPage: true, campEditKey: key, campDetail: camp });
    }
  };

  closeCampEditPage() {
    this.setState({ campEditPage: false, campDetail: {} });
    this.getCamps();
  }

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getCamps();
    });
  };

  updateCamp = async () => {
    try {
      let response = await Server.request({
        url: "camp/update",
        method: "POST",
        data: {
          campId: selectedCampId,
          isArchived: true,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: "Camp archived successfully",
          level: "success",
        });
        this.getCamps();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  hideUnhideCamp = async (obj) => {
    try {
      let response = await Server.request({
        url: "camp/update",
        method: "POST",
        data: obj,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getCamps();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeCamp = async (id) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "camp/delete",
        method: "POST",
        data: { campId: selectedCampId },
      });
      if (response) {
        this.setState({ showLoader: false });
        selectedCampId = null;
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getCamps();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadCSVData = async (campId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "camp/data/download",
        method: "POST",
        data: { campId },
      });
      if (response && response.success) {
        let csvData = response.csvData;
        csvData = csvData.map((data) => {
          if (data.birthday)
            Object.assign(data, {
              birthday: moment.utc(data.birthday).format("MM/DD/YYYY"),
            });
          return data;
        });
        this.setState({
          showLoader: false,
          csvData,
          csvHeaders: response.csvHeaders,
        });
      }
      this.csvLink.link.click();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleRemoveCampConfirmationModal = (id) => {
    if (id) {
      selectedCampId = id;
    }
    this.setState({
      removeCampConfirmationModal: !this.state.removeCampConfirmationModal,
    });
  };

  toggleArchiveCampConfirmationModal = (id) => {
    if (id) {
      selectedCampId = id;
    }
    this.setState({
      archiveCampConfirmationModal: !this.state.archiveCampConfirmationModal,
    });
  };

  collapseCampdetail = (id) => {
    if (
      !this.state.collapseCampdetail ||
      id !== this.state.collapseCampdetail
    ) {
      this.setState({
        collapseCampdetail: id,
      });
    } else if (this.state.collapseCampdetail === id) {
      this.setState({ collapseCampdetail: false });
    }
  };

  toggleTeamModel = (event) => {
    event.preventDefault();
    this.setState({
      teamModel: !this.state.teamModel,
    });
  };

  render() {
    return (
      <Fragment>
        {this.state.campEditPage ? (
          <RushDataEdit
            camp={this.state.campDetail || {}}
            campEditKey={this.state.campEditKey}
            closeCampEdit={() => this.closeCampEditPage()}
          ></RushDataEdit>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page
              title="Events"
              breadcrumbs={[{ name: "Events", active: true }]}
            >
              {user && user.name === "San Jose Rush" ? null : (
                <>
                  <Row style={{ marginTop: 10 }}>
                    <Col>
                      <Card>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            TOTAL ADULT MEMBERS REGISTERED
                          </div>
                          <div
                            style={{ fontSize: 35, color: "rgb(23, 81, 123)" }}
                          >
                            {(this.state.dashboardDetails &&
                              this.state.dashboardDetails.parent_members) ||
                              0}
                          </div>
                        </div>
                      </Card>
                    </Col>
                    <Col>
                      <Card style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            TOTAL CHILD MEMBERS REGISTERED
                          </div>
                          <div
                            style={{ fontSize: 35, color: "rgb(23, 81, 123)" }}
                          >
                            {(this.state.dashboardDetails &&
                              this.state.dashboardDetails.child_members) ||
                              0}
                          </div>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Card style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            INVOICED
                          </div>
                          <div style={{ fontSize: 35, color: "blue" }}>
                            ${" "}
                            {parseFloat(
                              (this.state.dashboardDetails &&
                                this.state.dashboardDetails.invoiced) ||
                                0
                            ).toFixed(2)}
                          </div>
                        </div>
                      </Card>
                    </Col>
                    <Col>
                      <Card style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            STRIPE BALANCE
                          </div>
                          <div
                            style={{
                              fontSize: 35,
                              marginTop: 3,
                              color: "green",
                            }}
                          >
                            ${" "}
                            {parseFloat(
                              (this.state.dashboardDetails &&
                                this.state.dashboardDetails.paid) ||
                                0
                            ).toFixed(2)}
                          </div>
                        </div>
                      </Card>
                    </Col>
                    <Col>
                      <Card style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            OUTSTANDING
                          </div>
                          <div style={{ fontSize: 35, color: "red" }}>
                            ${" "}
                            {parseFloat(
                              (this.state.dashboardDetails &&
                                this.state.dashboardDetails.pending) ||
                                0
                            ).toFixed(2)}
                          </div>
                        </div>
                      </Card>
                    </Col>
                    <Col>
                      <Card style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            REFUND
                          </div>
                          <div style={{ fontSize: 35, color: "red" }}>
                            ${" "}
                            {parseFloat(
                              (this.state.dashboardDetails &&
                                this.state.dashboardDetails.refund) ||
                                0
                            ).toFixed(2)}
                          </div>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Card>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            ADULT MEMBERS REGISTERED IN EVENTS
                          </div>
                          <div
                            style={{ fontSize: 35, color: "rgb(23, 81, 123)" }}
                          >
                            {(this.state.dashboardDetails &&
                              this.state.dashboardDetails
                                .parentRegisteredForEvent) ||
                              0}
                          </div>
                        </div>
                      </Card>
                    </Col>
                    <Col>
                      <Card style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: 5,
                            padding: 5,
                          }}
                        >
                          <div style={{ fontSize: 20, textAlign: "center" }}>
                            CHILD MEMBERS REGISTERED IN EVENTS
                          </div>
                          <div
                            style={{ fontSize: 35, color: "rgb(23, 81, 123)" }}
                          >
                            {(this.state.dashboardDetails &&
                              this.state.dashboardDetails
                                .childRegisteredForEvent) ||
                              0}
                          </div>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </>
              )}
              <Row>
                <Col>
                  <Card className="mb-3">
                    <CardHeader>
                      <Row>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex">
                            <div sm={4} className="mt-2 pr-2">
                              <Label>Shown</Label>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                name="pageLimit"
                                value={this.state.limit}
                                onChange={(event) => {
                                  this.refreshPagination(1, event.target.value);
                                  this.context.updateState({
                                    limit: event.target.value,
                                  });
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </Input>
                            </div>
                            <div sm={4} className="mt-2 pl-2">
                              <Label>entries</Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-center">
                            <div className="mt-2 pr-2">
                              <Label>
                                Showing{" "}
                                {!this.state.totalCamps
                                  ? 0
                                  : this.state.page * this.state.limit -
                                    (this.state.limit - 1) +
                                    " "}
                                to{" "}
                                {this.state.page * this.state.limit >
                                this.state.totalCamps
                                  ? this.state.totalCamps
                                  : this.state.page * this.state.limit}{" "}
                                of {this.state.totalCamps}
                              </Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-end">
                            <div sm={4} className="pr-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page <= 1}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page - 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                              </Button>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                value={this.state.page}
                                name="filter"
                                onChange={(event) => {
                                  this.refreshPagination(
                                    event.target.value,
                                    this.state.limit
                                  );
                                }}
                              >
                                {this.state.pageNumbers.length !== 0 ? (
                                  this.state.pageNumbers.map(
                                    (pageNumber, index) => (
                                      <option value={pageNumber} key={index}>
                                        {pageNumber}
                                      </option>
                                    )
                                  )
                                ) : (
                                  <option value={0}>0</option>
                                )}
                              </Input>
                            </div>
                            <div sm={4} className="pl-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page >= this.state.pages}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page + 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row className="mb-3">
                        <Col xl={6} lg={6} md={12} sm={12}>
                          {user.connectedUser && user.connectedUser.SPIEvent && (
                            <>
                              <Label for="name">Select Event :</Label>
                              <Select
                                value={this.state.selectedParentEvent}
                                options={[
                                  ...this.state.parentEvents.map(
                                    (parentEvent) => ({
                                      value: parentEvent._id,
                                      label: parentEvent.name,
                                    })
                                  ),
                                ]}
                                onChange={(result) =>
                                  this.setState(
                                    {
                                      selectedParentEvent: result,
                                      registerUrl: `${window.location.origin}/event/register/${result.label}`,
                                    },
                                    () => this.getCamps()
                                  )
                                }
                              />
                            </>
                          )}
                        </Col>
                        <Col
                          style={{ margin: "auto" }}
                          xl={6}
                          lg={6}
                          md={12}
                          sm={12}
                        >
                          <Button
                            style={{ float: "right" }}
                            onClick={(event) =>
                              this.renderCampEditPage({}, "Event-Create")
                            }
                          >
                            Create Event
                          </Button>
                        </Col>
                      </Row>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Price</th>
                            <th>StartingAt</th>
                            <th>EndingAt</th>
                            {user && user.name === "San Jose Rush" ? null : (
                              <>
                                <th>Invoiced</th>
                                <th>Paid</th>
                                <th>Pending</th>
                              </>
                            )}
                            <th>
                              {user.connectedUser && user.connectedUser.SPIEvent
                                ? "Registrations"
                                : "Players"}
                            </th>
                            <th>Teams</th>
                            {user.connectedUser && user.connectedUser.SPIEvent && (
                              <>
                                <th>Register link</th>
                              </>
                            )}
                            <th>Download Data</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.Camps && this.state.Camps.length > 0 ? (
                            this.state.Camps.map((camp, index) => (
                              <>
                                <tr key={index}>
                                  <td
                                    onClick={() =>
                                      this.collapseCampdetail(camp._id)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {camp.name}
                                  </td>
                                  <td>{parseFloat(camp.price).toFixed(2)}</td>
                                  <td>
                                    {moment
                                      .utc(camp.startingAt)
                                      .format("MM-DD-YYYY")}
                                  </td>
                                  <td>
                                    {camp.endingAt
                                      ? moment
                                          .utc(camp.endingAt)
                                          .format("MM-DD-YYYY")
                                      : "-"}
                                  </td>
                                  {user &&
                                  user.name === "San Jose Rush" ? null : (
                                    <>
                                      <td>
                                        {parseFloat(camp.invoiced || 0).toFixed(
                                          2
                                        )}
                                      </td>
                                      <td>
                                        {parseFloat(camp.paid || 0).toFixed(2)}
                                      </td>
                                      <td>
                                        {parseFloat(camp.pending || 0).toFixed(
                                          2
                                        )}
                                      </td>
                                    </>
                                  )}
                                  <td>{camp.registrations}</td>
                                  <td>
                                    <Label
                                      style={{ cursor: "pointer" }}
                                      className="text-primary "
                                      onClick={(event) => {
                                        this.setState({ camp: camp });
                                        this.toggleTeamModel(event);
                                      }}
                                    >
                                      View
                                    </Label>
                                  </td>
                                  {user.connectedUser &&
                                    user.connectedUser.SPIEvent && (
                                      <>
                                        <td>
                                          <a
                                            href={`${this.state.registerUrl}?eventId=${camp._id}`}
                                            target="_blank"
                                          >
                                            Register
                                          </a>
                                        </td>
                                      </>
                                    )}
                                  <td>
                                    <HiDownload
                                      size="20px"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.downloadCSVData(camp._id)
                                      }
                                    ></HiDownload>
                                    <CSVLink
                                      style={{ textDecoration: "unset" }}
                                      filename={`players.csv`}
                                      data={this.state.csvData}
                                      headers={this.state.csvHeaders}
                                      ref={(ref) => {
                                        this.csvLink = ref;
                                      }}
                                    ></CSVLink>
                                  </td>

                                  <td className="d-flex">
                                    {camp.showEvent ? (
                                      <Button
                                        id={`eyeTooltip${index}`}
                                        onClick={(event) =>
                                          this.hideUnhideCamp({
                                            campId: camp._id,
                                            showEvent: false,
                                          })
                                        }
                                        onMouseOver={() =>
                                          this.setState({
                                            selectedIndex: index,
                                            eyeTooltip: true,
                                          })
                                        }
                                        onMouseOut={() =>
                                          this.setState({
                                            selectedIndex: null,
                                            eyeTooltip: false,
                                          })
                                        }
                                      >
                                        <IoMdEye size="20px"></IoMdEye>
                                        <Tooltip
                                          placement={"bottom"}
                                          isOpen={
                                            this.state.eyeTooltip &&
                                            this.state.selectedIndex === index
                                          }
                                          target={`eyeTooltip${index}`}
                                          toggle={() => {}}
                                        >
                                          Hide Event
                                        </Tooltip>
                                      </Button>
                                    ) : (
                                      <Button
                                        id={`eyeOffTooltip${index}`}
                                        onClick={(event) =>
                                          this.hideUnhideCamp({
                                            campId: camp._id,
                                            showEvent: true,
                                          })
                                        }
                                        onMouseOver={() =>
                                          this.setState({
                                            selectedIndex: index,
                                            eyeOffTooltip: true,
                                          })
                                        }
                                        onMouseOut={() =>
                                          this.setState({
                                            selectedIndex: null,
                                            eyeOffTooltip: false,
                                          })
                                        }
                                      >
                                        <IoMdEyeOff size="20px"></IoMdEyeOff>
                                        <Tooltip
                                          placement={"bottom"}
                                          isOpen={
                                            this.state.eyeOffTooltip &&
                                            this.state.selectedIndex === index
                                          }
                                          target={`eyeOffTooltip${index}`}
                                          toggle={() => {}}
                                        >
                                          Unhide Event
                                        </Tooltip>
                                      </Button>
                                    )}
                                    <Button
                                      style={{ marginLeft: "10px" }}
                                      onClick={(event) =>
                                        this.renderCampEditPage(
                                          camp,
                                          "Event-Update"
                                        )
                                      }
                                    >
                                      <MdEdit size="20px"></MdEdit>
                                    </Button>
                                    <Button
                                      style={{ marginLeft: "10px" }}
                                      onClick={(event) =>
                                        this.toggleRemoveCampConfirmationModal(
                                          camp._id
                                        )
                                      }
                                    >
                                      <MdDeleteForever size="20px"></MdDeleteForever>
                                    </Button>
                                    <Button
                                      style={{ marginLeft: "10px" }}
                                      onClick={(event) =>
                                        this.renderCampEditPage(
                                          camp,
                                          "Event-Clone"
                                        )
                                      }
                                    >
                                      <FaClone size="20px"></FaClone>
                                    </Button>
                                    <Button
                                      style={{ marginLeft: "10px" }}
                                      onClick={(event) =>
                                        this.toggleArchiveCampConfirmationModal(
                                          camp._id
                                        )
                                      }
                                    >
                                      <FaArchive size="20px"></FaArchive>
                                    </Button>
                                  </td>
                                </tr>
                                {this.state.collapseCampdetail === camp._id && (
                                  <tr>
                                    <td colSpan="12">
                                      <EventDetails
                                        event={camp}
                                        SPIEvent={
                                          user.connectedUser &&
                                          user.connectedUser.SPIEvent
                                            ? true
                                            : false
                                        }
                                      />
                                    </td>
                                  </tr>
                                )}
                              </>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="12" className="text-center">
                                No events found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                    {this.state.removeCampConfirmationModal ? (
                      <Modal
                        isOpen={this.state.removeCampConfirmationModal}
                        toggle={(event) =>
                          this.toggleRemoveCampConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleRemoveCampConfirmationModal()
                          }
                        >
                          Delete Event
                        </ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this event ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleRemoveCampConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.removeCamp(selectedCampId);
                              this.toggleRemoveCampConfirmationModal();
                            }}
                          >
                            Delete
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                    {this.state.archiveCampConfirmationModal ? (
                      <Modal
                        isOpen={this.state.archiveCampConfirmationModal}
                        toggle={(event) =>
                          this.toggleArchiveCampConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleArchiveCampConfirmationModal()
                          }
                        >
                          Archive Event
                        </ModalHeader>
                        <ModalBody>
                          Are you sure you want to archive this event ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleArchiveCampConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.toggleArchiveCampConfirmationModal();
                              this.updateCamp(selectedCampId);
                            }}
                          >
                            Archive
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                    {this.state.teamModel ? (
                      <Modal
                        isOpen={this.state.teamModel}
                        toggle={(event) => this.toggleTeamModel(event)}
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) => this.toggleTeamModel(event)}
                        >
                          <Label>All Teams</Label>
                        </ModalHeader>
                        <ModalBody>
                          <div className="d-flex flex-wrap ">
                            {this.state.camp.allTeams &&
                            this.state.camp.allTeams.length > 0 ? (
                              this.state.camp.allTeams.map((team, index) => (
                                <Card
                                  key={index}
                                  className="d-flex justify-content-center mr-2"
                                >
                                  <Label className="m-2">{team.name}</Label>
                                </Card>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No teams found
                                </td>
                              </tr>
                            )}
                          </div>
                        </ModalBody>

                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) => this.toggleTeamModel(event)}
                          >
                            Close
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}
RushData.contextType = GlobalContext;
export default RushData;
